module.exports = new __parcel__URL__("clock-timer.e3a08b8b.png").toString();